module.exports = __webpack_public_path__ + "static/media/NoPath.908069ec.png";